export const baseIframeUrl = "https://moovitapp.com/israel-1/poi/"
export const customerId = "G8MC_Ex8IN0zXQ2QK2Xfsg"
// Configuration object for different locales
export const widgetLocaleConfig = {
  he: {
    scriptSrc:
      "https://widgets.moovit.com/ws/3335CD5034B15BFDE0630100007F53E9/5021024",
    dataId: "5021024",
    dataTitle: "חיפוש נסיעה בתחבורה ציבורית",
  },
  en: {
    scriptSrc:
      "https://widgets.moovit.com/ws/333547CDF52914E2E0630100007F547F/5020982",
    dataId: "5020982",
    dataTitle: "Search public transportation routes",
  },
  ar: {
    scriptSrc:
      "https://widgets.moovit.com/ws/3335F3F10339022EE0630100007F211C/5021066",
    dataId: "5021066",
    dataTitle: "البحث عن طرق النقل العام",
  },
  ru: {
    scriptSrc:
      "https://widgets.moovit.com/ws/3335FC71537F5BFAE0630100007FEC22/5021108",
    dataId: "5021108",
    dataTitle: "Поиск маршрутов общественного транспорта",
  },
}
